/*!

=========================================================
* Paper Dashboard React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from 'react'
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from 'perfect-scrollbar'
import { matchPath, Route, Switch } from 'react-router-dom'
import ProtectedRoute from '../components/ProtectedRoute'
import routes from 'routes.js'
import MainNavbar from '../components/Navbars/MainNavbar'
import SuiteSidebar from '../components/Navigation/SuiteSidebar'
import AppLauncherHost from '../components/AppLauncherHost/AppLauncherHost'
import API from '../api/API'
import style from './Admin.module.css'

var ps

class App extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      backgroundColor: 'black',
      activeColor: 'info',
      sidebarOpen: false,
      logoutHandler: null,
      navigationGuard: null,
      launcherOpen: false,
    }
    this.mainPanel = React.createRef()
    this.launcherRef = React.createRef()
    this.state.sessionSnapshot = props.authRuntime ? props.authRuntime.session.getSnapshot() : null
  }
  componentDidMount() {
    if (navigator.platform.indexOf('Win') > -1) {
      ps = new PerfectScrollbar(this.mainPanel.current)
      document.body.classList.toggle('perfect-scrollbar-on')
    }

    if (this.props.authRuntime) {
      this.unsubscribeSession = this.props.authRuntime.session.subscribe(sessionSnapshot => {
        this.setState({ sessionSnapshot, launcherOpen: false })
      })
      return
    }
    this.responseInterceptor = API.interceptors.response.use(
      res => {
        return res
      },
      err => {
        // if (!err.response || err.response.status >= 500 || err.response.status === 403) {
        if (
          (err && err.message === 'Network Error') ||
          (err && err.response && (err.response.status === 403 || err.response.status === 401) &&
            this.props.location.pathname !== '/signin' &&
            this.props.location.pathname !== '/resetear' &&
            this.props.location.pathname !== '/recuperar'&&
            this.props.location.pathname !== '/version')
        ) {
          this.props.cookies.remove('auth_token', { path: '/' })
          this.props.history.push('/login')
        }
        return Promise.reject(err)
      }
    )
  }
  componentWillUnmount() {
    if (this.responseInterceptor !== undefined) API.interceptors.response.eject(this.responseInterceptor)
    if (this.unsubscribeSession) this.unsubscribeSession()
    if (navigator.platform.indexOf('Win') > -1) {
      ps.destroy()
      document.body.classList.toggle('perfect-scrollbar-on')
    }
  }
  componentDidUpdate(e) {
    if (e.history.action === 'PUSH') {
      this.mainPanel.current.scrollTop = 0
      document.scrollingElement.scrollTop = 0
    }
  }
  handleActiveClick = color => {
    this.setState({ activeColor: color })
  }
  handleBgClick = color => {
    this.setState({ backgroundColor: color })
  }
  handleSidebarToggle = () => {
    this.setState(state => ({ sidebarOpen: !state.sidebarOpen }))
  }
  handleSidebarClose = () => {
    this.setState({ sidebarOpen: false })
  }
  handleLogoutReady = logoutHandler => {
    this.setState({ logoutHandler })
  }
  handleNavigationGuard = navigationGuard => {
    this.setState({ navigationGuard })
  }
  handleSidebarNavigation = destination => {
    this.state.navigationGuard(destination)
  }
  handleLauncherOpen = () => { this.setState({ launcherOpen: true }) }
  handleLauncherClose = () => { this.setState({ launcherOpen: false }) }
  render() {
    const authToken = this.props.authRuntime
      ? (this.props.authRuntime.session.check() ? this.props.authRuntime.session.readMarker() : null)
      : this.props.cookies.get('auth_token')
    const activeRoute = routes.find(route => matchPath(this.props.location.pathname, { path: route.path }))
    const showProtectedChrome = activeRoute && activeRoute.isProtected
    const mainPanelClassName = [
      'main-panel',
      showProtectedChrome && style.protectedPanel,
      showProtectedChrome && this.state.sidebarOpen && style.protectedPanelExpanded,
    ].filter(Boolean).join(' ')
    return (
      <div className="wrapper">
        {showProtectedChrome && (
          <MainNavbar
            authRuntime={this.props.authRuntime}
            authToken={authToken}
            isMenuOpen={this.state.sidebarOpen}
            onLogoutReady={this.handleLogoutReady}
            onLogoutStart={this.handleSidebarClose}
            onMenuToggle={this.handleSidebarToggle}
          />
        )}
        {showProtectedChrome && (
          <SuiteSidebar
            isOpen={this.state.sidebarOpen}
            onClose={this.handleSidebarClose}
            onLogout={this.state.logoutHandler}
            onNavigate={this.state.navigationGuard ? this.handleSidebarNavigation : null}
            onOpenLauncher={this.props.authRuntime ? this.handleLauncherOpen : null}
            launcherOpen={this.state.launcherOpen}
            launcherRef={this.launcherRef}
          />
        )}
        {showProtectedChrome && this.props.authRuntime && authToken && (
          <AppLauncherHost runtime={this.props.authRuntime} isOpen={this.state.launcherOpen}
            onClose={this.handleLauncherClose} returnFocusRef={this.launcherRef}
            navigationGuard={this.state.navigationGuard} />
        )}
        <div className={mainPanelClassName} ref={this.mainPanel}>
          <Switch>
            {routes.map((prop, key) => {
              const route = prop.isProtected ? ProtectedRoute : Route
              return React.createElement(route, {
                path: prop.path,
                render: routeProps => React.createElement(prop.component, {
                  ...routeProps,
                  authRuntime: this.props.authRuntime,
                  setNavigationGuard: this.handleNavigationGuard,
                }),
                session: this.props.authRuntime && this.props.authRuntime.session,
                key: key,
              })
            })}
          </Switch>
        </div>
      </div>
    )
  }
}

export default App
